// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3cYfC":[function(require,module,exports) {
var _indexJs = require("./index.js");

},{"./index.js":"fFaKF"}],"fFaKF":[function(require,module,exports) {
var global = arguments[3];
// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles
(function(modules, entry, mainEntry, parcelRequireName, globalName) {
    /* eslint-disable no-undef */ var globalObject = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
    /* eslint-enable no-undef */ // Save the require from previous bundle to this closure if any
    var previousRequire = typeof globalObject[parcelRequireName] === "function" && globalObject[parcelRequireName];
    var cache = previousRequire.cache || {};
    // Do not use `require` to prevent Webpack from trying to bundle this call
    var nodeRequire = typeof module.require === "function" && module.require.bind(module);
    function newRequire(name, jumped) {
        if (!cache[name]) {
            if (!modules[name]) {
                // if we cannot find the module within our internal map or
                // cache jump to the current global require ie. the last bundle
                // that was added to the page.
                var currentRequire = typeof globalObject[parcelRequireName] === "function" && globalObject[parcelRequireName];
                if (!jumped && currentRequire) return currentRequire(name, true);
                // If there are other bundles on this page the require from the
                // previous one is saved to 'previousRequire'. Repeat this as
                // many times as there are bundles until the module is found or
                // we exhaust the require chain.
                if (previousRequire) return previousRequire(name, true);
                // Try the node require function if it exists.
                if (nodeRequire && typeof name === "string") return nodeRequire(name);
                var err = new Error("Cannot find module '" + name + "'");
                err.code = "MODULE_NOT_FOUND";
                throw err;
            }
            localRequire.resolve = resolve;
            localRequire.cache = {};
            var module1 = cache[name] = new newRequire.Module(name);
            modules[name][0].call(module1.exports, localRequire, module1, module1.exports, this);
        }
        return cache[name].exports;
        function localRequire(x) {
            var res = localRequire.resolve(x);
            return res === false ? {} : newRequire(res);
        }
        function resolve(x) {
            var id = modules[name][1][x];
            return id != null ? id : x;
        }
    }
    function Module(moduleName) {
        this.id = moduleName;
        this.bundle = newRequire;
        this.exports = {};
    }
    newRequire.isParcelRequire = true;
    newRequire.Module = Module;
    newRequire.modules = modules;
    newRequire.cache = cache;
    newRequire.parent = previousRequire;
    newRequire.register = function(id, exports) {
        modules[id] = [
            function(require, module1) {
                module1.exports = exports;
            },
            {}
        ];
    };
    Object.defineProperty(newRequire, "root", {
        get: function() {
            return globalObject[parcelRequireName];
        }
    });
    globalObject[parcelRequireName] = newRequire;
    for(var i = 0; i < entry.length; i++)newRequire(entry[i]);
    if (mainEntry) {
        // Expose entry point to Node, AMD or browser globals
        // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
        var mainExports = newRequire(mainEntry);
        module.exports = mainExports;
    }
})({
    "3cYfC": [
        function(require, module1, exports) {
            /* features */ var _scripts = require("../features/modal/scripts");
            var _scripts1 = require("../features/bundles/scripts");
            var _scripts2 = require("../features/factories/scripts");
            var _scripts3 = require("../features/colorSwatches/scripts");
            var _scripts4 = require("../features/colorSwatchesScroller/scripts");
            var _scripts5 = require("../features/sizeGuide/scripts");
            var _scripts6 = require("../features/sectionFeatures/scripts");
            var _addresses = require("../features/customers/scripts/addresses");
            var _scripts7 = require("../features/mainProduct/scripts");
            var _scripts8 = require("../features/quickLinksScroll/scripts");
            var _scripts9 = require("../features/shippingModal/scripts");
            var _scripts10 = require("../features/announcementBar/scripts");
            var _scripts11 = require("../features/dixaMessenger/scripts");
        },
        {
            "../features/modal/scripts": "6S4Vn",
            "../features/bundles/scripts": "ckLS6",
            "../features/factories/scripts": "3iJcs",
            "../features/colorSwatches/scripts": "dk679",
            "../features/colorSwatchesScroller/scripts": "155Pz",
            "../features/sizeGuide/scripts": "8rkGq",
            "../features/sectionFeatures/scripts": "7LEx6",
            "../features/customers/scripts/addresses": "bDaHi",
            "../features/mainProduct/scripts": "bEHux",
            "../features/quickLinksScroll/scripts": "iURJB",
            "../features/shippingModal/scripts": "7URwb",
            "../features/announcementBar/scripts": "cN8Y4",
            "../features/dixaMessenger/scripts": "2sJHC"
        }
    ],
    "6S4Vn": [
        function(require, module1, exports) {
            class ModalElement extends HTMLElement {
                constructor(){
                    super();
                    this.body = document.body;
                    this.modalToggle = this.querySelector("button.modal__toggle");
                    this.modalContent = this.querySelector(".modal__content");
                    this.modalDialog = this.querySelector(".modal__dialog");
                    this.close = this.modalDialog?.querySelector(":scope > .modal__close-button");
                    console.log(this.close);
                    this.onOutsideClick = this.handleBodyClick.bind(this);
                    this.debouncedOnClick = debounce((event)=>{
                        this.modalClose(event);
                    });
                    this.debouncedOnToggleClick = debounce((event)=>{
                        this.onToggleClick(event);
                    });
                    this.modalToggle?.addEventListener("click", this.debouncedOnToggleClick.bind(this));
                    this.close?.addEventListener("click", this.debouncedOnClick.bind(this));
                }
                onToggleClick(event) {
                    event.preventDefault();
                    this.hasAttribute("open") ? this.modalClose(event) : this.open(event);
                }
                open() {
                    this.body.addEventListener("click", this.onOutsideClick);
                    this.dispatchEvent(new CustomEvent("modal-open"));
                    this.setAttribute("open", true);
                    this.body.classList.add("overflow-hidden");
                    if (this.closest(".product__info-wrapper")) this.closest(".product__info-wrapper").style.zIndex = 3;
                }
                modalClose(event) {
                    event && event.preventDefault();
                    this.dispatchEvent(new CustomEvent("modal-close"));
                    this.removeAttribute("open");
                    if (!this.parentElement.parentElement.classList.contains("bundle-product")) {
                        this.body.classList.remove("overflow-hidden");
                        if (this.closest(".product__info-wrapper")) this.closest(".product__info-wrapper").style.removeProperty("z-index");
                        else if (document.querySelector(".product__info-wrapper")) document.querySelector(".product__info-wrapper").style.removeProperty("z-index");
                    }
                    this.body.removeEventListener("click", this.onOutsideClick);
                }
                handleBodyClick(event) {
                    if (event.target.tagName.toLowerCase() !== "a") {
                        event.preventDefault();
                        if (event.target.classList.contains("modal-overlay")) {
                            if (this.hasAttribute("open")) this.modalClose(event);
                        }
                    }
                }
            }
            customElements.define("modal-popup", ModalElement);
            function debounce(fn, wait) {
                let t;
                return (...args)=>{
                    clearTimeout(t);
                    t = setTimeout(()=>fn.apply(this, args), wait);
                };
            }
        },
        {}
    ],
    "ckLS6": [
        function(require, module1, exports) {
            class BundleProduct extends HTMLElement {
                constructor(){
                    super();
                    this.selectedValues = [];
                    this.variantData = {};
                    this.configured = false;
                    this.setOrderDisplay(this.order);
                    this.setAvailableOptions();
                    this.addEvents();
                }
                set co2(co2) {
                    this.co2 = co2;
                }
                get co2() {
                    return parseInt(this.querySelector("[co2-footprint]")?.textContent);
                }
                set variantData(variantData) {}
                get variantData() {
                    let varId = null;
                    let varAvailable = false;
                    let firstAvailableVariant, foundFirstAvailableVariant = false;
                    this.querySelectorAll("#product-variant-ids option").forEach((opt)=>{
                        let productVariantNrs = [
                            "V1",
                            "V2",
                            "V3",
                            "V4",
                            "RPK"
                        ];
                        variantVersionLoop: for (const productVariantNr of productVariantNrs){
                            let selectedValues = productVariantNr + " / " + this.selectedValues[0] + " / " + this.selectedValues[1];
                            if (selectedValues.trim() == opt.textContent.trim()) {
                                varId = opt.value;
                                varAvailable = opt.getAttribute("available") === "true" ? true : false;
                                if (varAvailable && !foundFirstAvailableVariant) {
                                    foundFirstAvailableVariant = true;
                                    firstAvailableVariant = {
                                        id: varId,
                                        available: varAvailable
                                    };
                                    break variantVersionLoop;
                                }
                            }
                        }
                    });
                    return firstAvailableVariant || {
                        id: varId,
                        available: varAvailable
                    };
                }
                set productId(productId) {
                    this.setAttribute("prod-id", productId);
                }
                get productId() {
                    return this.getAttribute("prod-id");
                }
                set order(order) {
                    this.setAttribute("order", order);
                }
                get order() {
                    return this.getAttribute("data-order");
                }
                get selectors() {
                    return this.querySelectorAll("custom-select");
                }
                setAvailableOptions() {
                    //get variant ids and availability
                    const productVariantOptions = Array.from(this.querySelectorAll("#product-variant-ids option"));
                    const productVariantInfo = productVariantOptions.map((productVariantOption)=>[
                            productVariantOption.textContent,
                            productVariantOption.getAttribute("available")
                        ]);
                    //get all selectors, all options, and compare with the availability array combinations;
                    let productSelectors = [];
                    this.selectors.forEach((selector)=>{
                        productSelectors.push(selector.options);
                    });
                    // remove duplicates
                    let uniqueOptionTexts = {};
                    productSelectors.forEach((selector)=>{
                        selector.forEach((option)=>{
                            var text = option.textContent;
                            if (uniqueOptionTexts[text]) option.style.display = "none";
                            else uniqueOptionTexts[text] = true;
                        });
                    });
                    productSelectors.forEach((selector, selectorIndex)=>{
                        selector.forEach((option)=>{
                            let optionAvailability;
                            if (selectorIndex != 0 && this.selectedValues[0] != null) option.setAttribute("available", "false");
                            productVariantInfo.forEach((variant)=>{
                                let productVersionNrs = [
                                    "V1",
                                    "V2",
                                    "V3",
                                    "V4",
                                    "RPK"
                                ];
                                variantVersionLoop: for (const productVariant of productVersionNrs){
                                    let selectedValues = productVariant + " / " + this.selectedValues[0] + " / ";
                                    if (variant[0].includes(selectedValues + option.textContent)) {
                                        optionAvailability = variant[1];
                                        if (variant[1] == "true") {
                                            option.setAttribute("available", optionAvailability);
                                            break variantVersionLoop;
                                        }
                                    }
                                }
                            });
                        });
                    });
                }
                setOrderDisplay(order, color, configured) {
                    this.querySelector("[order-display] .color-swatch").textContent = order;
                    color && this.querySelector("[order-display]").setAttribute("data-color", color);
                    configured && this.querySelector("[order-display] [success-checkmark]").classList.remove("hidden");
                }
                addEvents() {
                    let _this = this;
                    this.selectors.forEach((selector)=>{
                        selector.addEventListener("click", function() {
                            _this.checkConfigured();
                            _this.setAvailableOptions();
                            _this.setConfiguredDisplay();
                        });
                    });
                }
                checkConfigured() {
                    let allSelectorsChosen = true;
                    this.selectedValues = [];
                    this.selectors.forEach((selector)=>{
                        if (selector.getAttribute("value") == null) allSelectorsChosen = false;
                        else this.selectedValues.push(selector.getAttribute("value"));
                    });
                    if (allSelectorsChosen) {
                        if (this.variantData.available == true) {
                            this.configured = true;
                            this.querySelector("[error-variant-unavailable]").classList.add("hidden");
                            this.color = this.querySelector(".select-selected").getAttribute("data-color");
                        } else this.querySelector("[error-variant-unavailable]").classList.remove("hidden");
                    }
                    this.parentNode.checkAddToCart();
                }
                setConfiguredDisplay() {
                    if (this.configured) {
                        this.setOrderDisplay("", this.color, true);
                        this.classList.add("configured");
                        this.setAttribute("configured", "");
                    } else this.setOrderDisplay(this.order);
                }
            }
            class BundleSelector extends HTMLElement {
                constructor(){
                    super();
                    this.addToCartBtn = this.parentElement.querySelector('button[name="add-bundle"]');
                    this.addToCartBtn.querySelector("span").textContent = this.addToCartBtn.dataset.initialText;
                    this.checkAddToCart();
                }
                set configuredBundles(configuredBundles) {}
                get configuredBundles() {
                    return this.querySelectorAll("bundle-product[configured]");
                }
                addProductListToCart(atcBtn, productsToAdd) {
                    const _this = this;
                    const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
                    if (productsToAdd.items.length >= 1) {
                        atcBtn.setAttribute("disabled", "");
                        atcBtn.querySelector("span").textContent = "Adding...";
                        productsToAdd.sections = cart.getSectionsToRender().map((section)=>section.id);
                        productsToAdd.sections_url = window.location.pathname;
                        fetch(window.Shopify.routes.root + "cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(productsToAdd)
                        }).then((response)=>{
                            return response.json();
                        }).then((data)=>{
                            atcBtn.removeAttribute("disabled", "");
                            atcBtn.querySelector("span").textContent = atcBtn.dataset.successText;
                            //close modal
                            document.querySelector("modal-popup.configure_bundle-modal").modalClose();
                            //cart
                            cart.setActiveElement(document.activeElement);
                            setTimeout(()=>{
                                cart.renderContents(data);
                            });
                            if (cart && cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
                            setTimeout(()=>{
                                cart.open();
                                atcBtn.querySelector("span").textContent = atcBtn.dataset.initialText;
                            }, 400);
                            if (data.status == 422) _this.parentElement.querySelector("[error-cart]").textContent = data.description;
                        }).catch((err)=>{});
                    }
                }
                atcHandler(e) {
                    e.preventDefault();
                    //FIXME: pass correct this
                    const _this = document.querySelector("bundle-selector");
                    const configuredBundles = _this.configuredBundles;
                    let productsToAdd = {
                        "items": []
                    };
                    for (let bundleProduct of configuredBundles){
                        let productObj = {
                            "id": bundleProduct.variantData.id,
                            "quantity": 1,
                            "properties": {
                                item_co2: bundleProduct.co2 || 0
                            }
                        };
                        if (productsToAdd.items.length > 0 && productsToAdd.items.filter((y)=>y.id === bundleProduct.variantData.id).length > 0) productsToAdd.items.find((y)=>y.id === bundleProduct.variantData.id).quantity++;
                        else productsToAdd.items.push(productObj);
                    }
                    _this.addProductListToCart(this, productsToAdd);
                }
                addCartEvent() {
                    this.addToCartBtn.removeEventListener("click", this.atcHandler);
                    this.addToCartBtn.addEventListener("click", this.atcHandler);
                }
                checkAddToCart() {
                    let allConfigured = true;
                    this.querySelectorAll("bundle-product").forEach((product)=>{
                        if (product.configured == false) allConfigured = false;
                        if (product.variantData.available == false) allConfigured = false;
                    });
                    if (allConfigured) {
                        this.addToCartBtn.removeAttribute("disabled");
                        this.addCartEvent();
                    } else this.addToCartBtn.setAttribute("disabled", "");
                }
            }
            customElements.define("bundle-product", BundleProduct);
            customElements.define("bundle-selector", BundleSelector);
        },
        {}
    ],
    "3iJcs": [
        function(require, module1, exports) {
            class FactoriesSection extends HTMLElement {
                constructor(){
                    super();
                    this.init();
                }
                setModalContent(modal, factory) {
                    this.propsToReplace.forEach((prop)=>{
                        modal.querySelector(prop).innerHTML = factory.querySelector(prop)?.innerHTML;
                    });
                    modal.querySelector("[data-img]").src = factory.querySelector("[data-img]").textContent;
                    return;
                }
                init() {
                    this.inited = false;
                    this.modal = this.querySelector("modal-popup");
                    this.factories = this.querySelectorAll("[data-factory]");
                    this.propsToReplace = [
                        "[data-city]",
                        "[data-country]",
                        "[data-description]",
                        "[data-family-run]",
                        "[data-founding-year]",
                        "[data-full-time]",
                        "[data-employees]",
                        "[data-overtime]",
                        "[data-employee-benefits]",
                        "[data-certifications]"
                    ];
                    this.addEvents();
                    this.inited = true;
                }
                addEvents() {
                    this.factories.forEach((factory)=>{
                        factory.addEventListener("click", ()=>{
                            this.setModalContent(this.modal, factory);
                        });
                    });
                }
            }
            customElements.define("factories-section", FactoriesSection);
        },
        {}
    ],
    "dk679": [
        function(require, module1, exports) {
            class ColorSwatches extends HTMLElement {
                constructor(){
                    super();
                    this.addEventListener("change", this.onColorSwatchChange);
                    if (this.dataset.event == "hover") this.querySelectorAll(".product-colors label.color").forEach((swatch)=>swatch.addEventListener("mouseenter", this.onColorSwatchHover.bind(this)));
                }
                onColorSwatchHover(event) {
                    if (!event.target.previousElementSibling.checked) {
                        event.target.previousElementSibling.checked = true;
                        if ("createEvent" in document) {
                            var evt = document.createEvent("HTMLEvents");
                            evt.initEvent("change", false, true);
                            this.dispatchEvent(evt);
                        } else this.fireEvent("onchange");
                    }
                }
                onColorSwatchChange() {
                    this.updateOptions();
                    this.updateMasterId();
                    if (this.currentVariant) {
                        const html = this.getProductData().find((product)=>product.id.toString() === this.connectedProductId).html;
                        this.renderProduct(html);
                    }
                }
                updateOptions() {
                    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
                    this.options = fieldsets.map((fieldset)=>{
                        return {
                            value: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).value,
                            connectedProductId: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).dataset.connectedProductId,
                            connectedProductHandle: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).dataset.handle
                        };
                    });
                }
                updateMasterId() {
                    this.productId = this.dataset.productId;
                    this.connectedProductId = this.options[0].connectedProductId;
                    this.connectedProductHandle = this.options[0].connectedProductHandle;
                    this.currentVariant = this.options[0].value;
                }
                renderProduct(html) {
                    const destination = document.querySelector(`#CardWrapper-${this.productId}`);
                    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
                    const source = parsedHtml.querySelector(`#CardWrapper-${this.connectedProductId}`);
                    if (destination && source) {
                        const destinationCardInner = destination.querySelector(".card > .card__inner");
                        const sourceCardInner = source.querySelector(".card > .card__inner");
                        if (destinationCardInner && sourceCardInner) destinationCardInner.innerHTML = sourceCardInner.innerHTML;
                        const destinationCardInfoMain = destination.querySelector(".card > .card__content > .card__information > .card-info__main");
                        const sourceCardInfoMain = source.querySelector(".card > .card__content > .card__information > .card-info__main");
                        if (destinationCardInfoMain && sourceCardInfoMain) destinationCardInfoMain.innerHTML = sourceCardInfoMain.innerHTML;
                        const destinationCardInfoPrice = destination.querySelector(".card > .card__content > .card__information > .card-info__price");
                        const sourceCardInfoPrice = source.querySelector(".card > .card__content > .card__information > .card-info__price");
                        if (destinationCardInfoPrice && sourceCardInfoPrice) destinationCardInfoPrice.innerHTML = sourceCardInfoPrice.innerHTML;
                        const destinationCardQuickAdd = destination.querySelector(".card > .card__content > .quick-add");
                        const sourceCardQuickAdd = source.querySelector(".card > .card__content > .quick-add");
                        if (destinationCardQuickAdd && sourceCardQuickAdd) destinationCardQuickAdd.innerHTML = sourceCardQuickAdd.innerHTML;
                        const destinationCardBadge = destination.querySelector(".card > .card__content > .card__badge");
                        const sourceCardBadge = source.querySelector(".card > .card__content > .card__badge");
                        if (destinationCardBadge && sourceCardBadge) destinationCardBadge.innerHTML = sourceCardBadge.innerHTML;
                        const destinationPromoCode1 = destination.querySelector(".card > .card__content > .card__information [data-promo-code-1]");
                        const sourcePromoCode1 = source.querySelector(".card > .card__content > .card__information [data-promo-code-1]");
                        if (destinationPromoCode1 && sourcePromoCode1) destinationPromoCode1.parentNode.replaceChild(sourcePromoCode1, destinationPromoCode1);
                        const destinationPromoCode2 = destination.querySelector(".card > .card__content > .card__information [data-promo-code-2]");
                        const sourcePromoCode2 = source.querySelector(".card > .card__content > .card__information [data-promo-code-2]");
                        if (destinationPromoCode2 && sourcePromoCode2) destinationPromoCode2.parentNode.replaceChild(sourcePromoCode2, destinationPromoCode2);
                    }
                }
                getProductData() {
                    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
                    return this.productData;
                }
            }
            ColorSwatches.productData = [];
            customElements.define("color-swatches", ColorSwatches);
        },
        {}
    ],
    "155Pz": [
        function(require, module1, exports) {
            //check overflowing swatches
            var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
            parcelHelpers.defineInteropFlag(exports);
            parcelHelpers.export(exports, "color_swatch_scroller", ()=>color_swatch_scroller);
            function color_swatch_scroller() {
                $("#product-grid li").each(function() {
                    if ($(this).width() < $(this).find(".product-colors").width()) {
                        $(this).addClass("overflowing");
                        $(this).find("color-swatches").width($(".card-wrapper").width() - 25);
                        $(this).find(".product-colors-scroll-right").show();
                    } else $(this).removeClass("overflowing");
                });
            }
            $(window).on("ready resize load", function() {
                color_swatch_scroller();
            });
            //click triggered scroll
            $(document).on("click", ".product-colors-scroll-right", function() {
                const $containerScroller = $(this).closest("#product-grid li.overflowing color-swatches");
                const $scrollerInner = $(this).closest("#product-grid li.overflowing color-swatches .product-colors");
                const $scrollWidth = 4 * ($("#product-grid li.overflowing color-swatches .color").width() + 5);
                $containerScroller.animate({
                    scrollLeft: $containerScroller.scrollLeft() + $scrollWidth + "px"
                });
            });
            //check scroller position
            document.addEventListener("scroll", function(event) {
                const $elm = event.target;
                if ($elm.tagName == "COLOR-SWATCHES") {
                    const $containerScroller = $elm;
                    const $scrollerInner = $($containerScroller).find(".product-colors");
                    let position = $scrollerInner.position();
                    let overflow = $($scrollerInner).width() - $($containerScroller).width();
                    if (position.left - 2 <= -overflow) $($containerScroller).find(".product-colors-scroll-right").hide("300");
                    else $($containerScroller).find(".product-colors-scroll-right").show("300");
                }
            }, true);
        },
        {
            "@parcel/transformer-js/src/esmodule-helpers.js": "gkKU3"
        }
    ],
    "gkKU3": [
        function(require, module1, exports) {
            exports.interopDefault = function(a) {
                return a && a.__esModule ? a : {
                    default: a
                };
            };
            exports.defineInteropFlag = function(a) {
                Object.defineProperty(a, "__esModule", {
                    value: true
                });
            };
            exports.exportAll = function(source, dest) {
                Object.keys(source).forEach(function(key) {
                    if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
                    Object.defineProperty(dest, key, {
                        enumerable: true,
                        get: function() {
                            return source[key];
                        }
                    });
                });
                return dest;
            };
            exports.export = function(dest, destName, get) {
                Object.defineProperty(dest, destName, {
                    enumerable: true,
                    get: get
                });
            };
        },
        {}
    ],
    "8rkGq": [
        function(require, module1, exports) {
            class SizeGuide extends HTMLElement {
                constructor(){
                    super();
                    this.chipLinks = this.querySelector(".chip-links").querySelectorAll(".chip-link");
                    this.chipContents = this.querySelector(".chip-contents").querySelectorAll(".chip-content");
                    this.chipLinks.forEach((chipLink)=>{
                        chipLink.classList.remove("active");
                        chipLink.addEventListener("click", this.onChipLinkClick.bind(this));
                    });
                    this.chipLinks[0].classList.add("active");
                    this.chipContents.forEach((chipContent)=>{
                        chipContent.classList.remove("active");
                    });
                    this.chipContents[0].classList.add("active");
                }
                onChipLinkClick(event) {
                    this.chipLinks.forEach((chipLink)=>{
                        chipLink.classList.remove("active");
                    });
                    event.target.classList.add("active");
                    var activeClass = "";
                    event.target.classList.forEach((chipLinkClass)=>{
                        if (chipLinkClass.includes("tab")) activeClass = chipLinkClass.split("-")[0];
                    });
                    this.chipContents?.forEach((chipContent)=>{
                        chipContent.classList.remove("active");
                    });
                    this.querySelector(`.${activeClass}-content`).classList.add("active");
                }
            }
            customElements.define("size-guide", SizeGuide);
            function debounce(fn, wait) {
                let t;
                return (...args)=>{
                    clearTimeout(t);
                    t = setTimeout(()=>fn.apply(this, args), wait);
                };
            }
        },
        {}
    ],
    "7LEx6": [
        function(require, module1, exports) {
            class FeaturesSection extends HTMLElement {
                constructor(){
                    super();
                    this.sectionFeatures = this.querySelectorAll(".section--features");
                    this.btns = this.querySelectorAll(".section--features .section--features__navigation > button");
                    this.init();
                }
                init() {
                    this.hideFeaturesSection();
                    this.sectionFeatures.forEach((block)=>{
                        block.querySelectorAll(".section--features__navigation > button").forEach((btn, i)=>{
                            const span = document.createElement("span");
                            span.classList.add("divider");
                            span.innerText = "/";
                            if (i != 0) btn.parentNode.insertBefore(span, btn);
                        });
                    });
                    this.btns.forEach((btn)=>{
                        btn.addEventListener("click", (e)=>{
                            e.preventDefault();
                            this.onNavClick(btn);
                        });
                    });
                }
                hideFeaturesSection() {
                    this.sectionFeatures.forEach((block, i)=>{
                        if (i != 0) block.classList.add("d-none");
                    });
                }
                onNavClick(btn) {
                    const block = this.getElementsByClassName(btn.dataset.block);
                    this.sectionFeatures.forEach((block)=>{
                        block.classList.add("d-none");
                    });
                    if (block) {
                        if (typeof block == "object") {
                            block[0].classList.remove("d-none");
                            block[0].classList.add("d-block");
                        } else {
                            block.classList.remove("d-none");
                            block.classList.add("d-block");
                        }
                    }
                }
            }
            customElements.define("features-section", FeaturesSection);
        },
        {}
    ],
    "bDaHi": [
        function(require, module1, exports) {},
        {}
    ],
    "bEHux": [
        function(require, module1, exports) {
            $(".chip.co2-label").on("click", function(event) {
                const sectionFeatures = $(".section--features.collection");
                if (sectionFeatures.length > 0) {
                    sectionFeatures.each((index)=>{
                        const element = sectionFeatures[index];
                        element.id != "features-footprint" ? element.classList.add("d-none") : element.classList.remove("d-none");
                    });
                    const scrollValue = $("#features-footprint").offset().top;
                    const animationTimeMilliseconds = 800;
                    // trigger scroll animation only if chip url setting is empty
                    if ($(this).attr("href") == "#") {
                        event.preventDefault();
                        $("html, body").animate({
                            scrollTop: scrollValue
                        }, animationTimeMilliseconds);
                    }
                }
            });
        },
        {}
    ],
    "iURJB": [
        function(require, module1, exports) {
            if (document.getElementById("popular--categories-container")) {
                const buttonLeft = document.getElementById("popular--categories-sliderLeft");
                const buttonRight = document.getElementById("popular--categories-sliderRight");
                const slider = document.querySelector(".popular-categories__categories-wrapper");
                let mouseDown = false;
                let startX, scrollLeft, startDraggingPosition;
                const removeArrow = ()=>{
                    const before = document.getElementById("popular--categories-container").scrollLeft;
                    document.getElementById("popular--categories-container").scrollLeft += 1;
                    if (document.getElementById("popular--categories-container").scrollLeft === before) {
                        buttonRight.style.opacity = 0;
                        buttonRight.style.cursor = "unset";
                    } else {
                        buttonRight.style.opacity = 1;
                        buttonRight.style.cursor = "pointer";
                    }
                    if (before === 0) {
                        buttonLeft.style.opacity = 0;
                        buttonLeft.style.cursor = "unset";
                    } else {
                        buttonLeft.style.opacity = 1;
                        buttonLeft.style.cursor = "pointer";
                    }
                };
                removeArrow();
                function scrollHorizontally(scroll) {
                    let i = 0;
                    const interval = setInterval(()=>{
                        if (i < 20) {
                            document.getElementById("popular--categories-container").scrollLeft += scroll;
                            removeArrow();
                            i++;
                        } else clearInterval(interval);
                    }, 15);
                }
                const scrollInterval = 5;
                buttonRight.addEventListener("click", ()=>scrollHorizontally(scrollInterval));
                buttonLeft.addEventListener("click", ()=>scrollHorizontally(-scrollInterval));
                let startDragging = function(e) {
                    mouseDown = true;
                    startX = e.pageX - slider.offsetLeft;
                    scrollLeft = slider.scrollLeft;
                };
                let stopDragging = function(event) {
                    mouseDown = false;
                };
                slider.addEventListener("mousemove", (e)=>{
                    e.preventDefault();
                    if (!mouseDown) return;
                    const x = e.pageX - slider.offsetLeft;
                    const scroll = x - startX;
                    slider.scrollLeft = scrollLeft - scroll;
                    removeArrow();
                });
                // Add the event listeners
                slider.addEventListener("mousedown", startDragging, false);
                slider.addEventListener("mouseup", stopDragging, false);
                slider.addEventListener("mouseleave", stopDragging, false);
            }
        },
        {}
    ],
    "7URwb": [
        function(require, module1, exports) {
            async function fetchLocationInformation() {
                let response = await fetch("https://api.ipstack.com/check?access_key=eb305bc275e44e3646e3466966e8a378");
                let data = await response.json();
                document.getElementById("shipping-search").value = data.country_name;
                $("#shipping-search").trigger("keyup");
            }
            async function fetchShippingRates() {
                let website = window.location.hostname;
                let region;
                switch(website){
                    case "dk.organicbasics.com":
                        region = "dk";
                        break;
                    case "uk.organicbasics.com":
                        region = "uk";
                        break;
                    case "us.organicbasics.com":
                        region = "us";
                        break;
                    case 'tarteletter.organicbasics.com"':
                        region = "dk";
                        break;
                    default:
                        region = "eu";
                }
                let response = await fetch(`http://api.organicbasics.com/api/shippingzones/${region}?format=json`);
                let data = await response.json();
                populateTable(data);
                inputCountryCheck();
            }
            let working_days = shippingTranslationKeys["shipping_modal.shipping_table.working_days"];
            function populateTable(data) {
                let countryListLength = document.querySelectorAll("tbody.country.tbody-country").length;
                if (countryListLength < 2) data.forEach((e)=>{
                    let o = $(".tbody-country:last");
                    o.clone().appendTo(".shipping-prices-table"), e.forEach(function(e, t) {
                        var n = o.find(".shipping-row:last");
                        n.clone().appendTo(o), n.append('<th class="shipping col--shipping" scope="row">'.concat(e.shipping_name, "</th>")), n.append('<td class="delivery col--delivery">'.concat(e.days, " ").concat(working_days, "</td>")), n.append('<td class="price">'.concat(e.price, " ").concat(e.currency, "</td>")), "N/A" === e.free_above ? n.append('<td class="free">'.concat(e.free_above, "</td>")) : n.append('<td class="free">'.concat(e.free_above, " ").concat(e.currency, "</td>"));
                    }), o.find(".shipping-row").eq(0).find(".col--country").text(e[0].country), o.find(".shipping-row").not(":eq(0)").find(".col--country").remove();
                });
            }
            function inputCountryCheck() {
                $(".shipping-info-container__table").each(function(e) {
                    var t = $(this);
                    t.find("#shipping-search").on("keyup loaded change ready focus", function() {
                        if ($(this).val().length > 2) {
                            var n = $(this).val().toLowerCase(), o = 0;
                            t.find("tbody.country").filter(function() {
                                var e = $(this), t = -1 < e.text().toLowerCase().indexOf(n);
                                e.toggle(t), o += t ? 1 : 0;
                            }), 0 === o && t.find("tbody.country").filter(function() {
                                var e = $(this), t = -1 < e.text().toLowerCase().indexOf("rest of world");
                                e.toggle(t);
                            });
                        } else t.find("tbody.country").filter(function() {
                            var e = $(this), t = -1 < e.text().toLowerCase().indexOf("rest of world");
                            e.toggle(t);
                        });
                    }), t.find("#shipping-search").trigger("keyup"), t.find("tbody.country").on("click", function() {
                        var e = $(this).find("p");
                        e.is("visible"), e.slideToggle("fast").toggleClass("el-content");
                    });
                });
            }
            document.querySelectorAll("#shopify-section-announcement-bar .announcement-bar[shipping-modal-enabled]").forEach((el)=>{
                el.addEventListener("click", function(event) {
                    document.querySelector(".shipping-modal").open();
                    return true;
                });
            });
            $(document).on("ready", function() {
                fetchLocationInformation();
                fetchShippingRates();
            });
        },
        {}
    ],
    "cN8Y4": [
        function(require, module1, exports) {
            $(document).on("ready", function() {
                const $wrapper = $(".announcement-bar__wrapper");
                const initialWraperHeight = parseInt($(".announcement-bar__wrapper").css("height"));
                if ($wrapper.length == 0) return;
                function mainCarouselFunc() {
                    const $announcementBarFirst = $wrapper.find(".announcement-bar[custom-color]");
                    const announcementBarFirstBgColor = $announcementBarFirst.eq(0).data("color");
                    const announcementBarFirstTextColor = $announcementBarFirst.eq(0).data("text-color");
                    $announcementBarFirst.css("background-color", announcementBarFirstBgColor);
                    $announcementBarFirst.find(".announcemet-bar__text").css("color", announcementBarFirstTextColor);
                    const messagesCount = $wrapper.find(".announcement-bar").not(".hidden").length;
                    const interval = $wrapper.data("interval") * 1000;
                    const transition = $wrapper.data("transition-speed");
                    const isCarousel = JSON.parse($wrapper.data("is-carousel"));
                    let transitionSpeed;
                    switch(transition){
                        case "swift":
                            transitionSpeed = 400;
                            break;
                        case "standard":
                            transitionSpeed = 600;
                            break;
                        case "slow":
                            transitionSpeed = 1000;
                            break;
                        default:
                            break;
                    }
                    if (messagesCount > 1 && isCarousel) setInterval(function() {
                        carousel();
                    }, interval);
                    $(".announcement-bar__wrapper").find(".announcement-bar").eq(0).addClass("active");
                    if (messagesCount > 1 && isCarousel) setInterval(carousel, interval);
                    function carousel() {
                        const $active = $(".announcement-bar__wrapper").find(".active");
                        const $next = $active.next(".announcement-bar").length ? $active.next(".announcement-bar") : $(".announcement-bar__wrapper .announcement-bar").first();
                        if ($wrapper.find(".announcement-bar").length < 2) return;
                        if ($($next).attr("custom-color"), $($next).attr("custom-color") !== false) {
                            $next.css("background-color", $next.data("color"));
                            $next.find(".announcemet-bar__text").css("color", $next.data("text-color"));
                        }
                        $active.fadeOut(transitionSpeed);
                        $next.fadeIn(transitionSpeed, function() {
                            $active.removeClass("active");
                            $next.addClass("active").css("opacity", "");
                            $next.css("color", $next.data("text-color"));
                            announcementBarIncreaseHeightOfParentMobile();
                        });
                    }
                }
                function mainCountdown() {
                    const shopName = $($wrapper).data("shop-name");
                    let timezone;
                    switch(shopName){
                        case "Organic Basics EU":
                            timezone = "Europe/Copenhagen";
                            break;
                        case "Organic Basics US":
                            timezone = "America/New_York";
                            break;
                        case "Organic Basics UK":
                            timezone = "Europe/London";
                            break;
                        default:
                            timezone = "Europe/Copenhagen";
                            break;
                    }
                    const now = new Date();
                    const currentDate = new Date(new Date().toLocaleString("en-US", {
                        timezone: timezone
                    }));
                    const currentTime = now.getTime();
                    const $wrapperCountdown = $(".announcement-countdown");
                    $($wrapperCountdown).each(function() {
                        const $currEl = $(this);
                        const $currWrapper = $($currEl).closest(".announcement-bar__wrapper");
                        const $currItem = $($currEl).closest(".announcement-bar");
                        itemCountdown($currEl, $currWrapper, $currItem);
                    });
                    function itemCountdown($currEl, $currWrapper, $currItem) {
                        // Set due date 
                        const dueDateVal = $($currEl).data("due-date");
                        let dueDateArr = dueDateVal.split(",");
                        // Remove all empty spaces
                        dueDateArr = dueDateArr.map((s)=>s.trim());
                        // Change strings to number
                        dueDateArr = dueDateArr.map((str)=>Number(str));
                        dueDateArr[1] = dueDateArr[1] - 1;
                        const dueDate = new Date(new Date(dueDateArr[0], dueDateArr[1], dueDateArr[2], dueDateArr[3], dueDateArr[4]).toLocaleString("en-US", {
                            timezone: timezone
                        }));
                        const dueEventTime = dueDate.getTime();
                        const remTime = dueEventTime - currentTime;
                        // Set from date
                        const fromDateVal = $($currEl).data("from-date");
                        let fromDateArr = fromDateVal.split(",");
                        // Remove all empty spaces
                        fromDateArr = fromDateArr.map((s)=>s.trim());
                        // Change strings to number
                        fromDateArr = fromDateArr.map((str)=>Number(str));
                        fromDateArr[1] = fromDateArr[1] - 1;
                        const fromDate = new Date(new Date(fromDateArr[0], fromDateArr[1], fromDateArr[2], fromDateArr[3], fromDateArr[4]).toLocaleString("en-US", {
                            timezone: timezone
                        }));
                        const fromEventTime = fromDate.getTime();
                        if (fromEventTime > currentTime) $currItem.remove();
                        if (dueEventTime < currentTime) $currItem.remove();
                        let sec = Math.floor(remTime / 1000);
                        let min = Math.floor(sec / 60);
                        let hour = Math.floor(min / 60);
                        let day = Math.floor(hour / 24);
                        hour %= 24;
                        min %= 60;
                        sec %= 60;
                        (function renderTime() {
                            $($currEl).find(".days").text(day);
                            $($currEl).find(".hours").text(hour);
                            $($currEl).find(".minutes").text(min);
                            $($currEl).find(".seconds").text(sec);
                        })();
                    }
                    setTimeout(mainCountdown, 1000);
                }
                function notShownOnThisPage() {
                    $wrapper.find(".not-shown-on-this-page").remove();
                    if ($wrapper.children().length == 0) $wrapper.remove();
                }
                notShownOnThisPage();
                mainCountdown();
                mainCarouselFunc();
                // Second call serves as a callback function once carousel changed DOM
                notShownOnThisPage();
                function announcementBarIncreaseHeightOfParentMobile() {
                    const $wrapper = $(".announcement-bar__wrapper");
                    const $active = $wrapper.find(".announcement-bar.active");
                    const $content = $active.find(".announcemet-bar__text");
                    const lineHeight = parseInt($($content).css("line-height"));
                    const lines = parseInt($($content).height() / lineHeight);
                    const increase = 15;
                    // Only applies for mobile devices and block contian more than two lines 
                    if (window.outerWidth < 768 && lines > 2) {
                        const calculateIncreasedHeight = initialWraperHeight + (lines - 2) * increase;
                        $wrapper.css("height", `${calculateIncreasedHeight}px`);
                    } else $wrapper.css("height", `${initialWraperHeight}px`);
                }
                announcementBarIncreaseHeightOfParentMobile("", "INITIAL");
            });
        },
        {}
    ],
    "2sJHC": [
        function(require, module1, exports) {
            window.addEventListener("DOMContentLoaded", (event)=>{
                let target = document.getElementById("dixa-messenger-placeholder");
                if (target) {
                    const dixaid = document.getElementById("dixa-messenger-placeholder").getAttribute("data-dixaid");
                    const observer = new MutationObserver(function(mutationList) {
                        mutationList.forEach(function(mutation) {
                            mutation.addedNodes.forEach(function(added_node) {
                                if (added_node.className == "dixa-messenger-namespace") {
                                    setTimeout(()=>{
                                        _dixa_.invoke("setWidgetOpen", true);
                                    }, "2000");
                                    observer.disconnect();
                                }
                            });
                        });
                    });
                    observer.observe(document.querySelector("body"), {
                        subtree: false,
                        childList: true
                    });
                    target.addEventListener("click", (event)=>{
                        (function(w, d, s) {
                            if (w._dixa_) return;
                            w._dixa_ = {
                                invoke: function(m, a) {
                                    w._dixa_.pendingCalls = w._dixa_.pendingCalls || [];
                                    w._dixa_.pendingCalls.push([
                                        m,
                                        a
                                    ]);
                                },
                                addListener: function(event, listener) {
                                    w._dixa_.pendingAddListenerCalls = w._dixa_.pendingAddListenerCalls || [];
                                    w._dixa_.pendingAddListenerCalls.push([
                                        event,
                                        listener
                                    ]);
                                }
                            };
                            s = d.createElement("script");
                            s.type = "text/javascript";
                            s.setAttribute("charset", "utf-8");
                            s.async = true;
                            s.src = "https://messenger.dixa.io/bootstrap.js";
                            var before = d.getElementsByTagName("script")[0];
                            before.parentNode.insertBefore(s, before);
                        })(window, document);
                        _dixa_.invoke("init", {
                            position: "bottomLeft",
                            showWidgetCloseButton: true,
                            messengerToken: dixaid
                        });
                    });
                }
            });
        },
        {}
    ]
}, [
    "3cYfC"
], "3cYfC", "parcelRequirebae4") //# sourceMappingURL=main.js.map
;

},{}]},["3cYfC"], "3cYfC", "parcelRequirebae4")

//# sourceMappingURL=parcel_scripts.js.map
